var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStandard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "invoice (4)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6130",
  d: "M91.936 16.129h-11.29V0H33.201L19.355 13.848v2.281H8.065a8.074 8.074 0 0 0-8.064 8.065v58.064a8.074 8.074 0 0 0 8.065 8.065H27.42v6.452h-6.452V100h58.065v-3.226h-6.452v-6.451h19.355a8.074 8.074 0 0 0 8.065-8.065V24.194a8.074 8.074 0 0 0-8.065-8.065Zm-1.613 61.29h-9.677V25.806h9.677Zm-12.9 0H22.581v-61.29h12.9V3.226H77.42Zm-58.065 0h-9.68V25.806h9.677ZM24.862 12.9l7.4-7.4v7.4ZM3.226 24.194a4.845 4.845 0 0 1 4.839-4.839h11.29v3.226H9.678a3.229 3.229 0 0 0-3.226 3.226v51.612H3.226Zm66.129 72.58H30.646v-6.451h38.71Zm27.42-14.516a4.845 4.845 0 0 1-4.839 4.842H8.065a4.845 4.845 0 0 1-4.839-4.839v-1.616h93.549Zm-3.226-4.839V25.806a3.229 3.229 0 0 0-3.226-3.226h-9.677v-3.225h11.29a4.845 4.845 0 0 1 4.839 4.839v53.225Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6131",
  d: "M25.807 74.193h48.387V25.806H25.807Zm3.226-35.484h9.674v32.258H29.03Zm12.9 32.258V38.706h29.032v32.258Zm29.032-35.484H41.936v-6.452h29.032Zm-32.258-6.451v6.452H29.03v-6.452Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6132",
  d: "M32.259 41.936h3.226v3.226h-3.226Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6133",
  d: "M45.162 41.936h3.226v3.226h-3.226Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6134",
  d: "M51.614 41.936h16.129v3.226H51.614Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6135",
  d: "M45.162 48.387h22.581v3.226H45.162Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6136",
  d: "M32.259 58.065h3.226v3.226h-3.226Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6137",
  d: "M45.162 58.065h3.226v3.226h-3.226Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6138",
  d: "M51.614 58.065h16.129v3.226H51.614Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6139",
  d: "M45.162 64.516h22.581v3.226H45.162Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6140",
  d: "M50.001 6.452h24.194v3.226H50.001Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6141",
  d: "M50.001 12.903h11.29v3.226h-11.29Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6142",
  d: "M64.517 12.903h9.677v3.226h-9.677Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6143",
  d: "M50.001 19.355h24.194v3.226H50.001Zm0 0"
}))));
export default SvgStandard;